import { render, staticRenderFns } from "./ListTabel.vue?vue&type=template&id=3ca82a38&"
import script from "./ListTabel.vue?vue&type=script&lang=js&"
export * from "./ListTabel.vue?vue&type=script&lang=js&"
import style0 from "./ListTabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ca82a38')) {
      api.createRecord('3ca82a38', component.options)
    } else {
      api.reload('3ca82a38', component.options)
    }
    module.hot.accept("./ListTabel.vue?vue&type=template&id=3ca82a38&", function () {
      api.rerender('3ca82a38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/Role/components/ListTabel.vue"
export default component.exports